<template>
  <v-alert type="warning" :value="!fetchCompanyPending && !company.active_subscription">
    {{ $t('texts.subscriptionRequiredText') }}
    <v-btn
      :to="{ name: 'subscription.admin' }"
      outlined
      color="white"
      small
    >
      {{ $t('texts.subscriptionInformation') }}
    </v-btn>
  </v-alert>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');

export default {
  name: 'SubscriptionRequired',
  computed: {
    ...mapCompanyProfileState([
      'fetchCompanyPending',
      'company',
    ]),
  },
};
</script>
